import { render, staticRenderFns } from "./Promises.vue?vue&type=template&id=6e515e35&"
import script from "./Promises.vue?vue&type=script&lang=js&"
export * from "./Promises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports